import { Breadcrumb, Icon, Spinner, SpinnerSize } from '@fluentui/react';
import * as React from 'react';

import { DataOwnerRecord } from '../../../Common/DataOwnerModels/DataOwnerRecord';
import * as Styled from '../../../Common/Styles/portalManagement.styled';

type DataOwnerDetailsHeaderProps = {
  dataOwnerRecord: DataOwnerRecord;
};

export function DataOwnerDetailsHeaderLoading(): React.ReactElement {
  return (
    <Styled.LoadingContainer data-testid="heading-section-loading">
      <Spinner size={SpinnerSize.large} />
    </Styled.LoadingContainer>
  );
}

export function DataOwnerDetailsHeader(props: DataOwnerDetailsHeaderProps): React.ReactElement {
  const { dataOwnerRecord } = props;

  return (
    <Styled.HeaderContainer data-testid="heading-container">
      <Breadcrumb
        styles={Styled.portalManagementStyles}
        ariaLabel="Breadcrumb bar with data owner page link and current data owner name"
        items={[
          {
            href: '/dataOwners',
            key: 'dataOwners',
            text: 'DataOwners',
          },
          {
            isCurrentItem: true,
            key: 'dataOwnerName',
            text: dataOwnerRecord.name,
          },
        ]}
      />
      <Styled.DetailsContainer>
        <title>{dataOwnerRecord.name}</title>

        <Styled.PortalManagementTitleText>{dataOwnerRecord.name}</Styled.PortalManagementTitleText>

        <Styled.PortalManagementDetails>

          <Styled.TypeValueContainer>
            <Styled.Type>DataOwner ID</Styled.Type>
            <Styled.Value>{dataOwnerRecord.id}</Styled.Value>
          </Styled.TypeValueContainer>

          <Styled.TypeValueContainer>
            <Styled.Type>Security Group</Styled.Type>
            <Styled.Value>{dataOwnerRecord.securityGroup}</Styled.Value>
          </Styled.TypeValueContainer>

          <Styled.TypeValueContainer>
            <Styled.Type>Service Tree ID</Styled.Type>
            <Styled.Value>
              <a href={`https://microsoftservicetree.com/services/${dataOwnerRecord.serviceTreeID}`} target="_blank" rel="noopener noreferrer" aria-label='Open Service Tree'>
                {dataOwnerRecord.serviceTreeID}&nbsp;
                <Icon
                  data-testid="Service-Tree-Link"
                  aria-label="Service Tree Link"
                  iconName="OpenInNewWindow"
                  aria-hidden="true"
                />
              </a>
            </Styled.Value>
          </Styled.TypeValueContainer>

          <Styled.TypeValueContainer>
            <Styled.Type>Service Tree Name</Styled.Type>
            <Styled.Value>{dataOwnerRecord.serviceTreeName}</Styled.Value>
          </Styled.TypeValueContainer>
          
        </Styled.PortalManagementDetails>
      </Styled.DetailsContainer>
    </Styled.HeaderContainer>
  );
}
